import React, { useState, useEffect } from "react";
import { useParams, generatePath, useHistory } from "react-router-dom";

import PageContainer from "components/lib/PageContainer";
import { Loader, Button } from "semantic-ui-react";

import { Container } from "components/Post/News/Index/Container";
import { UserContainer } from "containers";
import { StoreIdParam } from "config/raven";
import { newsService } from "domain/service";
import routes from "utils/routes";
import {
  ApplyTemplateModal,
  Category as ApplyTemplateCategory,
} from "components/lib/ApplyTemplateModal";
import { newsRepository } from "domain/repository";
import {
  NoTemplateModal,
  Category as NoTemplateCategory,
} from "components/lib/NoTemplateModal";
import { StoreBreadcrumbBuilder } from "utils/breadcrumb";

export const NewsIndex = () => {
  const userContainer = UserContainer.useContainer();
  const { isAgency } = userContainer;
  const { storeId } = useParams<StoreIdParam>();

  const [isTemplateExist, setIsTemplateExist] = useState<boolean | null>(null);

  // Modal State
  const [openApplyTemplateModal, setOpenApplyTemplateModal] = useState(false);

  const history = useHistory();

  useEffect(() => {
    const fetchTemplate = () => {
      newsService.fetchNewsTemplate(isAgency, storeId).then((template) => {
        if (template === null) {
          setIsTemplateExist(false);
        } else {
          setIsTemplateExist(true);
        }
      });
    };
    fetchTemplate();
  }, [isAgency, storeId]);

  const getContents = () => {
    // テンプレート
    if (isTemplateExist === null) {
      return <Loader active />;
    }
    if (!isTemplateExist) {
      return (
        <NoTemplateModal
          category={NoTemplateCategory.NEWS}
          handleTemplatePageButton={() => {
            const templatePageUrl = isAgency
              ? generatePath(routes.agency.newsTemplate.pathname, {
                  storeId,
                })
              : routes.store.newsTemplate.pathname;
            history.push(templatePageUrl);
          }}
        />
      );
    }

    return (
      <>
        <ApplyTemplateModal
          open={openApplyTemplateModal}
          setOpen={(open: boolean) => setOpenApplyTemplateModal(open)}
          applyTemplate={() =>
            newsRepository.applyNewsTemplate(isAgency, storeId)
          }
          category={ApplyTemplateCategory.NEWS}
        />
        <Button
          color="red"
          content="テンプレートの一括適用"
          onClick={() => setOpenApplyTemplateModal(true)}
        />

        <Container isAgency={isAgency} storeId={storeId} />
      </>
    );
  };

  return (
    <PageContainer
      header="お知らせ一覧"
      breadcrumbs={new StoreBreadcrumbBuilder(isAgency, storeId).build(
        "お知らせ一覧"
      )}
      action={
        <Button
          color="blue"
          content="新規投稿"
          onClick={() => {
            const newsNewUrl = isAgency
              ? generatePath(routes.agency.newsNew.pathname, {
                  storeId,
                })
              : routes.store.newsNew.pathname;
            history.push(newsNewUrl);
          }}
        />
      }
    >
      {getContents()}
    </PageContainer>
  );
};
